// extracted by mini-css-extract-plugin
export var inlineVideo = "serializers-module--inlineVideo--6e9a5";
export var largeLink = "serializers-module--largeLink--893b1";
export var link = "serializers-module--link--bf38e";
export var mediumLink = "serializers-module--mediumLink--84b8f";
export var smallLink = "serializers-module--smallLink--0fefd";